import ProfileDetailsForm from '../../component/Profile/ProfileDetailsForm';

const ProfileRoute = [
  {
    path: '/home/Stores/Profile/details',
    exact: true,
    name: 'Profile-details',
    Component: ProfileDetailsForm
  },
  {
    path: '/home/Stores/Profile/add',
    exact: true,
    name: 'Profile-details',
    Component: ProfileDetailsForm
  },
  {
    path: '/home/Stores/Profile/edit',
    exact: true,
    name: 'Profile-details',
    Component: ProfileDetailsForm
  }
];

export default ProfileRoute;
